import CheliaL1 from '../../../src/media/SCG Landscape (1)/Chelia (1).webp'
import CheliaL2 from '../../../src/media/SCG Landscape (1)/Chelia (2).webp'
import CheliaL3 from '../../../src/media/SCG Landscape (1)/Chelia (3).webp'
import CheliaL4 from '../../../src/media/SCG Landscape (1)/Chelia (4).webp'
import CheliaL5 from '../../../src/media/SCG Landscape (1)/Chelia (5).webp'
import CheliaL6 from '../../../src/media/SCG Landscape (1)/Chelia (6).webp'



const CheliaLimages =[
CheliaL1,CheliaL2,CheliaL3,CheliaL4,CheliaL5,CheliaL6
]

export default CheliaLimages;